import React from "react";
import { Tooltip, makeStyles } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === "dark";
  return {
    badge: {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "3px 9px 3px 8px",
      borderRadius: 999,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: 0.2,
      lineHeight: 1,
      verticalAlign: "middle",
      userSelect: "none",
      transition: "background 0.18s ease, color 0.18s ease",
    },
    online: {
      color: isDark ? "#86efac" : "#16a34a",
      background: isDark ? "rgba(34,197,94,0.14)" : "rgba(34,197,94,0.12)",
      border: `1px solid ${
        isDark ? "rgba(34,197,94,0.30)" : "rgba(34,197,94,0.25)"
      }`,
    },
    offline: {
      color: isDark ? "#9ca3af" : "#6b7280",
      background: isDark ? "rgba(148,163,184,0.10)" : "rgba(15,23,42,0.05)",
      border: `1px solid ${
        isDark ? "rgba(148,163,184,0.20)" : "rgba(15,23,42,0.10)"
      }`,
    },
    dot: {
      width: 8,
      height: 8,
      borderRadius: "50%",
      flexShrink: 0,
    },
    dotOnline: {
      background: "#22c55e",
      boxShadow: "0 0 0 0 rgba(34,197,94,0.55)",
      animation: "$pulseOnline 1.8s ease-out infinite",
    },
    dotOffline: {
      background: isDark ? "#6b7280" : "#94a3b8",
    },
    "@keyframes pulseOnline": {
      "0%": {
        boxShadow: "0 0 0 0 rgba(34,197,94,0.55)",
      },
      "70%": {
        boxShadow: "0 0 0 6px rgba(34,197,94,0)",
      },
      "100%": {
        boxShadow: "0 0 0 0 rgba(34,197,94,0)",
      },
    },
  };
});

const UserStatusIcon = ({ user }) => {
  const classes = useStyles();
  const isOnline = !!user.online;

  return (
    <Tooltip
      title={
        isOnline ? i18n.t("userStatus.online") : i18n.t("userStatus.offline")
      }
    >
      <span
        className={`${classes.badge} ${
          isOnline ? classes.online : classes.offline
        }`}
      >
        <span
          className={`${classes.dot} ${
            isOnline ? classes.dotOnline : classes.dotOffline
          }`}
        />
        {isOnline
          ? i18n.t("userStatus.online")
          : i18n.t("userStatus.offline")}
      </span>
    </Tooltip>
  );
};

export default UserStatusIcon;
